import React from "react";

export default function AppButton({
  children,
  onClick,
  fromColor,
  toColor ,
  hoverFrom ,
  hoverTo ,
  className ,
  ...props
}) {
  return (
    <button
      className={`
        py-3 px-8 font-bold text-white rounded-2xl 
        bg-gradient-to-r from-${fromColor} to-${toColor}
        hover:from-${hoverFrom} hover:to-${hoverTo}
        transition-all duration-300
        ${className}
      `}
      onClick={onClick}
      {...props}
    >
      {children}
    </button>
  );
}
